import { AxiosResponse } from "axios";
import { axiosInstance, MessageResponse } from "./common";
import { Stakeholder } from "./stakeholders";
import { StakeholderRelationship } from "./stakeholder_relationships";

export enum CreditAccountProduct{
    USED_CAR_LOAN = "Used Car Loan",
    PERSONAL_LOAN = "Personal Loan",
    AUTO_LOAN = "Auto Loan",
    HOME_LOAN = "Home Loan",
    CREDIT_CARD = "Credit Card",
    LOAN_AGAINST_PROPERTY = "Loan Against Property",
    BUSINESS_LOAN = "Business Loan",
    CORPORATE_LOAN = "Corporate Loan",
    GOLD_LOAN = "Gold Loan",
    TWO_WHEELER_LOAN = "Two-Wheeler Loan",
    EDUCATION_LOAN = "Education Loan",
    AGRICULTURE_LOAN = "Agriculture Loan",
    OTHERS = "Others"
}

export const BUSINESS_PRODUCTS: CreditAccountProduct[] = [
  CreditAccountProduct.BUSINESS_LOAN,
  CreditAccountProduct.CORPORATE_LOAN,
];

export enum CreditFacility {
    TERM_LOAN = "TERM_LOAN",
    CASH_CREDIT = "CASH_CREDIT",
    OVERDRAFT = "OVERDRAFT",
    DEMAND_LOAN = "DEMAND_LOAN",
    BILLS_PURCHASED = "BILLS_PURCHASED",
    BILLS_DISCOUNTED = "BILLS_DISCOUNTED",
    PACKING_CREDIT = "PACKING_CREDIT",
    BANK_GUARANTEE = "BANK_GUARANTEE",
    LETTER_OF_CREDIT = "LETTER_OF_CREDIT",
    LETTER_OF_UNDERTAKING = "LETTER_OF_UNDERTAKING",
    ACCEPTANCE = "ACCEPTANCE",
    OTHERS = "OTHERS"
}

export const CREDIT_FACILITY_LABELS: Record<CreditFacility, string> = {
  [CreditFacility.TERM_LOAN]: "Term Loan",
  [CreditFacility.CASH_CREDIT]: "Cash Credit",
  [CreditFacility.OVERDRAFT]: "Overdraft",
  [CreditFacility.DEMAND_LOAN]: "Demand Loan",
  [CreditFacility.BILLS_PURCHASED]: "Bills Purchased",
  [CreditFacility.BILLS_DISCOUNTED]: "Bills Discounted",
  [CreditFacility.PACKING_CREDIT]: "Packing Credit",
  [CreditFacility.BANK_GUARANTEE]: "Bank Guarantee",
  [CreditFacility.LETTER_OF_CREDIT]: "Letter of Credit",
  [CreditFacility.LETTER_OF_UNDERTAKING]: "Letter of Undertaking",
  [CreditFacility.ACCEPTANCE]: "Acceptance",
  [CreditFacility.OTHERS]: "Others",
};

export interface CreditAccount {
    account_number: string;
    ext_account_number: string;
    account_name: string;
    product: CreditAccountProduct;
    credit_facility: CreditFacility;
}

export interface CreateCreditAccountData extends CreditAccount {
    primary_borrower_stakeholder_id?: string;
}

interface CreateCreditAccountsRequest {
    credit_accounts: CreateCreditAccountData[];
    stakeholders?: Stakeholder[];
}

export interface CreateCreditAccountsResponse {
  credit_accounts: CreditAccount[];
  stakeholders?: Stakeholder[] ;
  stakeholder_relationships?: StakeholderRelationship[];
}

export interface UpdateCreditAccountRequest{
    account_name?: string;
    product?: CreditAccountProduct;
    credit_facility?: CreditFacility;
}

export const CreditAccountsAPI = {
    add: async (case_id: string, credit_accounts: CreateCreditAccountData[], stakeholders?: Stakeholder[]) => {
        const request: CreateCreditAccountsRequest = {
            credit_accounts: credit_accounts,
            stakeholders: stakeholders,
        }

        const response: AxiosResponse<CreateCreditAccountsResponse> = 
            await axiosInstance.post(`/v1/cases/${case_id}/credit-accounts`, request);

        return response.data;
    },
    update: async (case_id: string, account_number: string, request: UpdateCreditAccountRequest) => {
        const response: AxiosResponse<MessageResponse> = 
            await axiosInstance.patch(`/v1/cases/${case_id}/credit-accounts/${account_number}`, request);

        return response.data;
    }
}

